export const STANDARD_PREVIEW_IMAGE =
    'https://cdn.dst.vistaprint.io/DefaultCartImages/StandardDify.png';

export const DRAFT_BRIEF_STATUS = 'DRAFT_BRIEF_REQUEST_IN_PROGRESS';
